// Resource File URL Handler
// 修复Shopify文件URL问题，确保文件能正确打开

// 立即定义全局函数
window.debugResourceFiles = function() {
    const resourceItems = document.querySelectorAll('.resource-item');
    console.log('Found', resourceItems.length, 'resource items');
    
    resourceItems.forEach((item, index) => {
        console.log(`Resource ${index + 1}:`, {
            debugUrl: item.getAttribute('data-debug-url'),
            debugFile: item.getAttribute('data-debug-file'),
            fileType: item.getAttribute('data-file-type')
        });
    });
};

// 函数：从各种格式中提取文件名
function extractFileName(url) {
    if (!url) return null;
    
    // 如果是完整URL，提取文件名
    if (url.includes('/')) {
        return url.split('/').pop();
    }
    
    // 如果已经是文件名
    return url;
}

// 函数：构建Shopify CDN URL
function buildShopifyCdnUrl(fileName) {
    const origin = window.location.origin;
    return `${origin}/cdn/shop/files/${fileName}`;
}

// 函数：智能解析文件URL
function parseFileUrl(debugUrl, debugFile) {
    let fileName = null;
    let finalUrl = null;
    
    // 尝试解析文件数据
    try {
        const fileData = JSON.parse(debugFile);
        
        // 检查不同的URL格式
        if (fileData && typeof fileData === 'object') {
            if (fileData.url) {
                finalUrl = fileData.url;
            } else if (fileData.value && fileData.value.url) {
                finalUrl = fileData.value.url;
            } else if (typeof fileData === 'string') {
                finalUrl = fileData;
            }
        }
    } catch (e) {
        finalUrl = debugUrl;
    }
    
    // 如果没有找到URL，使用debugUrl
    if (!finalUrl) {
        finalUrl = debugUrl;
    }
    
    // 提取文件名
    fileName = extractFileName(finalUrl);
    
    // 如果文件名存在，构建正确的Shopify CDN URL
    if (fileName) {
        const cdnUrl = buildShopifyCdnUrl(fileName);
        return cdnUrl;
    }
    
    // 如果已经是完整的CDN URL，直接返回
    if (finalUrl && finalUrl.includes('cdn.shopify.com')) {
        return finalUrl;
    }
    
    // 如果是相对路径，转换为绝对路径
    if (finalUrl && finalUrl.startsWith('/')) {
        return window.location.origin + finalUrl;
    }
    
    // 最后的备选方案
    return finalUrl;
}

document.addEventListener('DOMContentLoaded', function() {
    // 处理所有资源项目的点击事件
    const resourceItems = document.querySelectorAll('.resource-item');
    
    resourceItems.forEach(item => {
        // 移除原有的onclick事件，使用JavaScript处理
        item.removeAttribute('onclick');
        
        item.addEventListener('click', function() {
            const debugUrl = this.getAttribute('data-debug-url');
            const debugFile = this.getAttribute('data-debug-file');
            
            // 使用智能解析获取最佳URL
            const finalUrl = parseFileUrl(debugUrl, debugFile);
            
            // 检查URL是否有效
            if (finalUrl && finalUrl.startsWith('http')) {
                // 直接打开文件
                window.open(finalUrl, '_blank');
            } else {
                alert('无法确定文件URL。请检查文件设置。');
            }
        });
    });
}); 